import moment from 'moment'

export const DATE_FORMAT = 'DD/MM/YYYY'
const SERVER_DATE_FORMAT = 'YYYY-MM-DD'
export const getDefaultMoment = (date: string) => (date ? moment(date) : undefined)
export const getDDMMYYYY = (date: string) => (date ? moment(date).format(DATE_FORMAT) : undefined)
export const getFormDateToYYYYMMDD = (date: any) => {
  return date ? moment(date.toISOString()).format(SERVER_DATE_FORMAT) : undefined
}
